import { Download, Monitor, Keyboard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { KIOSKO_DOWNLOAD_URL } from "@/utils/newBodyFeatures";

export const KioskoDownloadCard = () => {
  return (
    <Card className="border-primary/30 bg-gradient-to-br from-primary/5 to-transparent">
      <CardHeader>
        <div className="flex items-start gap-3">
          <div className="rounded-lg bg-primary/10 p-2">
            <Monitor className="h-5 w-5 text-primary" />
          </div>
          <div className="flex-1">
            <CardTitle className="text-lg">Modo Kiosko (PC del mostrador)</CardTitle>
            <CardDescription className="mt-1">
              App de escritorio para Windows. Captura el numpad físico y registra la entrada
              de los socios sin afectar tu panel de manager en otra pestaña.
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button asChild size="lg" className="w-full sm:w-auto">
          <a href={KIOSKO_DOWNLOAD_URL} download>
            <Download className="mr-2 h-4 w-4" />
            Descargar para Windows (~100 MB)
          </a>
        </Button>

        <div className="rounded-lg border border-border/50 bg-muted/30 p-4 text-sm space-y-2">
          <p className="font-medium flex items-center gap-2">
            <Keyboard className="h-4 w-4" /> Cómo usarlo
          </p>
          <ol className="list-decimal list-inside space-y-1 text-muted-foreground">
            <li>Descomprimí el archivo <code className="px-1 rounded bg-background">.zip</code>.</li>
            <li>Doble click en <code className="px-1 rounded bg-background">ClubbersKiosko.exe</code>.</li>
            <li>Iniciá sesión con la cuenta de monitor del gym.</li>
            <li>
              Atajo <code className="px-1 rounded bg-background">Ctrl + Alt + K</code> para
              pausar la captura del numpad si necesitás usarlo en otra app.
            </li>
          </ol>
        </div>
      </CardContent>
    </Card>
  );
};
